import React, {Component} from 'react';
import PropTypes from "prop-types";
import Select from 'react-select';

class SortSelector extends Component {

    static propTypes = {
        options: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    static defaultProps = {
        activeView: 'smallView',
        options: [],
        selected: '',
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.translate;

        this.onClickHandle = this.onClickHandle.bind(this);

    }

    onClickHandle(sorter) {

        if (this.props.onClick) {
            this.props.onClick(sorter);
        }

    }

    getSortOptions() {

        return this.props.options;

    }

    render() {

        if (this.props.activeView === 'tableView') return null;

        const sortedOptions = this.getSortOptions();

        return (
            <span className="sortSelector">
                <Select
                    name="form-sort-selector"
                    className="chosen-container chosen-container-single"
                    style={{width: '200px'}}
                    options={sortedOptions}
                    onChange={this.onClickHandle}
                    value={this.props.selected}
                    placeholder={this.translate('sorting')}
                    clearable={true}
                    noResultsText={this.translate('noResultsFound')}
                />
            </span>
        );

    }

}

export default SortSelector;